import TabSelect from 'components/TabSelect'
import { useTranslation } from 'contexts/Localization'
import useTokenCoinGeckoPrice from 'hooks/useTokenCoinGeckoPrice'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'state'
import { updateReportStaking } from 'state/staking/action'
import { fetchStakingReport } from 'state/staking/api'
import { setRefReports, updateReport } from 'state/tree/actions'
import { getRefReport } from 'state/tree/api'
import { useUserData } from 'state/user/hooks/useUserData'
import getWalletReport from 'state/wallet/fetch/getWalletReport'
import getWalletSummary from 'state/wallet/fetch/getWalletSummary'
import { useGetUsdtWallet } from 'state/wallet/useGetWalletData'
import { setWalletSummary } from 'state/wallet/actions'

import Commission from './Commission'
import FundingView from './FundingView'
import Staking from './Staking'

const WalletTabs = () => {
  const { t } = useTranslation()
  const { query, replace } = useRouter()
  const dispatch = useDispatch()

  const userData = useUserData()
  const myWallet = useGetUsdtWallet()

  const { balances, opvPrice } = useSelector((state: any) => state.wallet)
  const walletSummary = useSelector((state: AppState) => state.wallet.walletSummary)
  const usdtPrice = useTokenCoinGeckoPrice('USDT')

  // Set State
  const [paramRateTotalBalance, setParamRateTotalBalance] = useState({
    range: 7,
    type: 'TOTAL_BALANCE',
  })
  const [paramComAvailable, setParamComAvailable] = useState({
    range: 7,
    type: 'COM_AVAILABLE',
  })
  const [paramComTotal, setParamComTotal] = useState({
    range: 7,
    type: 'COM_TOTAL',
  })
  const [paramComWithdraw, setParamComWithdraw] = useState({
    range: 7,
    type: 'COM_WITHDRAW',
  })
  const [paramComLimit, setParamComLimit] = useState({
    range: 7,
    type: 'COM_LIMIT',
  })
  const [paramStakingEarn, setParamStakingEarn] = useState({
    range: 7,
    type: 'STAKING_EARN',
  })
  const [paramStakingLock, setParamStakingLock] = useState({
    range: 7,
    type: 'STAKING_LOCK',
  })

  const [rate, setRate] = useState({
    rateTotalBalance: 0,
    rateComAvailable: 0,
    rateComTotal: 0,
    rateComWithdraw: 0,
    rateComLimit: 0,
    rateStakingEarn: 0,
    rateStakingLock: 0,
  })

  const tabIndex = useMemo(() => {
    try {
      return Number(query?.tabIndex ?? 1)
    } catch {
      return 1
    }
  }, [query?.tabIndex])

  // Function
  const onTabChange = useCallback(
    (value) => {
      replace(
        {
          query: {
            tabIndex: value,
          },
        },
        undefined,
        { scroll: false },
      )
    },
    [replace],
  )

  // Render view
  const renderView = () => {
    if (tabIndex === 2) {
      return (
        <></>
        // <Commission
        //   balances={balances}
        //   usdtPrice={usdtPrice?.price}
        //   walletSummary={walletSummary}
        //   rate={rate}
        //   setParamComAvailable={setParamComAvailable}
        //   setParamComTotal={setParamComTotal}
        //   setParamComWithdraw={setParamComWithdraw}
        //   setParamComLimit={setParamComLimit}
        // />
      )
    }

    if (tabIndex === 3) {
      return (
        <Staking
          walletSummary={walletSummary}
          rate={rate}
          setParamStakingEarn={setParamStakingEarn}
          setParamStakingLock={setParamStakingLock}
        />
      )
    }

    return (
      <FundingView
        userData={userData}
        myWallet={myWallet}
        balances={balances}
        opvPrice={opvPrice}
        usdtPrice={usdtPrice?.price}
        perCentBalance={rate?.rateTotalBalance}
        setParamBalance={setParamRateTotalBalance}
      />
    )
  }

  useEffect(() => {
    fetchStakingReport().then((res) => {
      dispatch(updateReportStaking(res))
    })
  }, [dispatch])

  // fetch data
  useEffect(() => {
    getRefReport(userData?.id).then((res) => {
      dispatch(setRefReports(res))
    })

    getWalletSummary((res) => dispatch(setWalletSummary(res)))
  }, [dispatch, userData?.id])

  useEffect(() => {
    getWalletReport(paramRateTotalBalance, (res) => setRate((prev) => ({ ...prev, rateTotalBalance: +res?.rate })))
  }, [paramRateTotalBalance?.range])

  useEffect(() => {
    getWalletReport(paramComAvailable, (res) => setRate((prev) => ({ ...prev, rateComAvailable: +res?.rate })))
  }, [paramComAvailable?.range])

  useEffect(() => {
    getWalletReport(paramComTotal, (res) => setRate((prev) => ({ ...prev, rateComTotal: +res?.rate })))
  }, [paramComTotal?.range])

  useEffect(() => {
    getWalletReport(paramComWithdraw, (res) => setRate((prev) => ({ ...prev, rateComWithdraw: +res?.rate })))
  }, [paramComWithdraw?.range])

  useEffect(() => {
    getWalletReport(paramComLimit, (res) => setRate((prev) => ({ ...prev, rateRateComLimit: +res?.rate })))
  }, [paramComLimit?.range])

  useEffect(() => {
    getWalletReport(paramStakingEarn, (res) => setRate((prev) => ({ ...prev, rateStakingEarn: +res?.rate })))
  }, [paramStakingEarn?.range])

  useEffect(() => {
    getWalletReport(paramStakingLock, (res) => setRate((prev) => ({ ...prev, rateStakingLock: +res?.rate })))
  }, [paramStakingLock?.range])

  return (
    <>
      <TabSelect
        active={tabIndex}
        onChange={onTabChange}
        data={[
          { index: 1, value: t('Funding') },
          // { index: 2, value: t('Commission') },
        ]}
        className="mb-4"
      />

      {renderView()}
    </>
  )
}

export default WalletTabs
